import { Brand, SocialLink } from '@waitroom/models';
import { commonConfig } from '../modules/core/config';

const { socials: s, emails } = commonConfig.company;

export const socials: SocialLink[] = [
  { platform: Brand.TWITTER, url: s.twitter },
  { platform: Brand.LINKEDIN, url: s.linkedin },
  {
    platform: 'email',
    url: `mailto:${emails.contact}`,
  },
];
